import axiosInstance from '../utils/axiosInstance.js';
import { route_readings, route_devices} from "../constants/BackendRoutes.js";

/**
 * Fetches the device readings from the backend
 * @param {string} deviceId id for the device
 * @param {string} startDateTime start Date time for the query, in format of 2026-08-06T11:00:00.000Z
 * @param {string} endDateTime  end Date time for the query, in format of 2026-08-06T11:00:00.000Z
 * @param {string} yields       yields from which to get the readings, could be "all" or "last"
 * @param {string} fields   fields to get the readings for must be in format of a string with comma separated values, e.g. "temperature,humidity",
 *                          for a single value just "temperature" is okay.
 * @returns                 data for the readings, if successful, otherwise error.
 *                          Data will be in the format:
 *                          [
 *                            {
 *                              key: "temperature",
 *                              value: 23.4,
 *                              units: "°C",
 *                              timestamp: "2021-08-10T00:00:00Z"
 *                            },
 *                            {
 *                              key: "humidity",
 *                              value: 0.6,
 *                              units: "%",
 *                              timestamp: "2021-08-10T00:00:00Z"
 *                            },
 *                            {
 *                              ...
 *                            },
 *                            ...
 *                          ]
 */
export async function fetchDeviceReadings(deviceId, startDateTime, endDateTime, yields, fields) {
  const fieldString = fields.join(",");
  try {
    const request = `${route_readings}/${deviceId}`;
    console.log(request);

    // backend need to be utc time
    const startUtc = new Date(startDateTime).toISOString();
    const endUtc = new Date(endDateTime).toISOString();

    const response = await axiosInstance.get(request, {
      params: {
        startDateTime: startUtc,
        endDateTime: endUtc,
        yield: yields,
        fields: fieldString,
      },
    });
    return response.data;
  } catch (error) {
    if ('status' in error)
    {
      console.log(`Backend not responding: ${error.status} error`);
    }
    else
    {
      console.error("Error fetching device readings: ", error);
    }
    return null;
  }
}


/**
 * Fetches the device object array from the database
 * @returns Object containing all of the data for the main device table
 */
export async function fetchDeviceTableData() {
  try {
    console.log(route_devices);
    const response = await axiosInstance.get(route_devices);
    return response.data;
  } catch (error) {
    if ('status' in error)
    {
      console.log(`Backend not responding: ${error.status} error`);
    }
    else
    {
      console.error("Error fetching Device List:", error);
    }
    return null;
  }
}
